import { useRef } from "react";
import Card from "@material-tailwind/react/Card";
import CardHeader from "@material-tailwind/react/CardHeader";
import CardBody from "@material-tailwind/react/CardBody";
import InputIcon from "@material-tailwind/react/InputIcon";
import DataTable from "react-data-table-component";
import Button from "@material-tailwind/react/Button";
import React from "react";
import { Link } from "react-router-dom/cjs/react-router-dom.min";

export default function CardTable({ playerReferral, pending, usernameEvent, onChangeRowsPerPage }) {
    const columns = [
        {
            name: "Username",
            selector: (row, idx) => row.username,
            sortable: true,
        },
        {
            name: "First Deposit Date",
            selector: (row) => row.first_dp_date,
            sortable: true,
        },
        {
            name: "First Dp Amount",
            selector: (row) => 'Rp. ' + row.first_dp_amnt,
            sortable: true,
        },
        {
            name: "Last Login IP",
            selector: (row) => row.last_login_ip,
            sortable: true,
        },
        {
            name: "Bank Name",
            selector: (row) => row.bank_name,
            sortable: true,
        },
        {
            name: "Phone",
            selector: (row) => row.phone_number,
            sortable: true,
        },
        {
            name: "Bank Acc Name",
            selector: (row) => row.bank_acc_name,
            sortable: true,
        },
        {
            name: "Bank Acc Number",
            selector: (row) => row.bank_acc_num,
            sortable: true,
        },
    ];

    const handleExport = (dataJson) => {
        const header = '"username","First Deposit Date","First Dp Amount","Last Login IP","Bank Name","Phone","Bank Acc Name","Bank Acc Number",\n';
        const csvData = dataJson.map(d => `"${d.username}","${d.first_dp_date}","${d.first_dp_amnt}","${d.last_login_ip}","${d.bank_name}",'${d.phone_number},"${d.bank_acc_name}",'${d.bank_acc_num},\n`).join('');
        const blob = new Blob([header + csvData], { type: 'text/csv;charset=utf-8;' });
        const link = document.createElement('a');

        link.href = URL.createObjectURL(blob);
        link.setAttribute('download', 'player-referral-first-deposit.csv');
        document.body.appendChild(link);
        link.click();
        link.remove();
    };

    return (
        <div>
            <div>
                <Card className="mt-12">
                    <CardHeader color="blueGray" contentPosition="left">
                        <h2 className="text-white text-2xl">Player Referral First Deposit</h2>
                    </CardHeader>
                    <CardBody >
                        <Button onClick={() => handleExport(playerReferral)}>Export To CSV</Button>
                        <DataTable
                            columns={columns}
                            data={playerReferral}
                            progressPending={pending}
                            onChangeRowsPerPage={onChangeRowsPerPage}
                            paginationRowsPerPageOptions={[10, 50, 100, 500]}
                            pagination
                        />
                    </CardBody>
                </Card>
            </div>
        </div>
    );
}